import userInfoRoutes from '../../modules/userInfo/routes/index';
import reportBugRoutes from '../../modules/reportBug/routes/index';
import emailToFindRoutes from '../../modules/emailToFind/routes/index';
import integrationRoutes from '../../modules/integration/routes/index';

export default [
  ...userInfoRoutes,
  ...reportBugRoutes,
  ...emailToFindRoutes,
  ...integrationRoutes,
];
